
import { cn } from "@/lib/utils";
import { LucideIcon } from "lucide-react";
import React from "react";

interface IncisionTemplateItemProps {
  icon: LucideIcon;
  label: string;
  onClick: (e?: React.MouseEvent) => void;
  active?: boolean;
  disabled?: boolean;
  danger?: boolean;
}

export const IncisionTemplateItem: React.FC<IncisionTemplateItemProps> = ({
  icon: Icon,
  label,
  onClick,
  active = false,
  disabled = false,
  danger = false,
}) => {
  return (
    <div
      onClick={disabled ? undefined : onClick}
      className={cn(
        "template-item flex items-center gap-2 px-2 py-1.5 rounded-lg cursor-pointer transition-colors",
        active && "active bg-slate-100 text-blue-700",
        disabled && "opacity-50 cursor-not-allowed",
        danger && "text-red-600 hover:bg-red-50",
        !active && !disabled && !danger && "hover:bg-slate-50",
      )}
    >
      <Icon className="h-4 w-4" strokeWidth={2} />
      <span className="text-sm">{label}</span>
    </div>
  );
};
